export default "__VITE_ASSET__CbuM7Sra__"